import { Chip } from "@mui/material";
import React from "react";

export const ShoppingCartFreeAmount = (props: {amount: number; unit: string}) => {
    return <Chip sx={{ width: "70px" }} size="small" label={`${props.amount}${props.unit}`} />;
};
